exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-277d45a9]{position:fixed;left:0;bottom:0;width:100vw;background-color:#2020e0;background-repeat:repeat-x;animation-name:background-move-right-data-v-277d45a9;animation-timing-function:linear;animation-iteration-count:infinite;font-family:Roboto}@keyframes background-move-right-data-v-277d45a9{0%{background-position:0 0}to{background-position:100vw 0}}@keyframes background-move-left-data-v-277d45a9{0%{background-position:0 0}to{background-position:-100vw 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-277d45a9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/objects/misc/ScrollingObject.vue
// module id = 64
// module chunks = 0